import { render, staticRenderFns } from "./OrderExchangeRecive.vue?vue&type=template&id=e6a785a0&scoped=true"
import script from "./OrderExchangeRecive.vue?vue&type=script&lang=js"
export * from "./OrderExchangeRecive.vue?vue&type=script&lang=js"
import style0 from "./OrderExchangeRecive.vue?vue&type=style&index=0&id=e6a785a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a785a0",
  null
  
)

export default component.exports